/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_SubInputs */

const en_fw_bm_sub = /** @type {(inputs: Fw_Bm_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First-attempt verification rate by agent, task tier and criterion kind — measured on real tasks, not a quiz.`)
};

const id_fw_bm_sub = /** @type {(inputs: Fw_Bm_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat lolos verifikasi percobaan pertama per agen, tingkat task, dan jenis kriteria — diukur dari task nyata, bukan kuis.`)
};

/**
* | output |
* | --- |
* | "First-attempt verification rate by agent, task tier and criterion kind — measured on real tasks, not a quiz." |
*
* @param {Fw_Bm_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_sub = /** @type {((inputs?: Fw_Bm_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_sub(inputs)
	return en_fw_bm_sub(inputs)
});